// Page rules matcher — shared between AnalyticsLoader and admin preview.
//
// A pattern is a glob-like URL path:
//   single-star   — matches anything except slash
//   double-star   — matches anything including slash
//   exact match otherwise (e.g. "/en/pricing")
//
// Examples:
//   "/en/<star>"              → /en, /en/pricing (but NOT /en/business/slug)
//   "/en/<starstar>"          → /en, /en/pricing, /en/business/anything
//   "/<star>/pricing"         → /en/pricing, /ru/pricing, /he/pricing
//   "/<star>/business/<starstar>" → /en/business/slug, /ru/business/shop-01, ...
//   "/en/pricing"             → exact match only

function globToRegex(pattern) {
  const escaped = pattern
    .replace(/[.+^${}()|[\]\\]/g, "\\$&") // escape regex specials
    .replace(/\*\*/g, "§§DOUBLESTAR§§")
    .replace(/\*/g, "[^/]*")
    .replace(/§§DOUBLESTAR§§/g, ".*");
  return new RegExp(`^${escaped}$`);
}

/** Match a single path against a pattern. */
export function matchPattern(pathname, pattern) {
  if (!pattern) return false;
  // Strip query/hash if present
  const clean = pathname.split(/[?#]/)[0];
  try {
    return globToRegex(pattern).test(clean);
  } catch {
    return false;
  }
}

/**
 * Check whether a script should load on the current page based on rules.
 * @param {string} pathname  — e.g. "/en/pricing"
 * @param {{mode, patterns}} rules
 * @returns {boolean}
 */
export function shouldLoadOnPage(pathname, rules) {
  if (!rules || rules.mode === "all" || !Array.isArray(rules.patterns) || rules.patterns.length === 0) {
    return true;
  }
  const anyMatch = rules.patterns.some((p) => matchPattern(pathname, p));
  if (rules.mode === "include") return anyMatch;
  if (rules.mode === "exclude") return !anyMatch;
  return true;
}

/** Preview which of a list of paths the rules will match (for admin UI). */
export function previewMatches(paths, rules) {
  return paths.map((p) => ({ path: p, match: shouldLoadOnPage(p, rules) }));
}
